import API from "../axiosConfig";

export const   getTariffPeriods = async () => {
  try {
    const response = await API.get("/tariff-periods");
    return response.data;
  } catch (error) {
    console.error("Error fetching tariff-periods:", error);
    throw error;
  }
};


export const createTariffPeriod = async (lineData) => {
  try {
    const response = await API.post("/tariff-periods", lineData);
    return response.data;
  } catch (error) {
    console.error("Error creating tariff-periods:", error);
    throw error;
  }
};

export const updateTariffPeriod = async (lineId, lineData) => {
  try {
    const response = await API.put(`/tariff-periods/${lineId}`, lineData);
    return response.data;
  } catch (error) {
    console.error("Error updating tariff-periods:", error);
    throw error;
  }
};